import { GET_ROUTES, GET_ROUTE, SYNC_ROUTES } from "../constants/action-types";

import Axios from "axios";

import { getApiCodes, getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/* 
    Get a list of routes.
*/
export const getRoutes = (callback) => (dispatch) => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/routes`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_ROUTES,
      payload: res.data.routes
    });

    callback(true);
  }).catch((error) => {
    console.log(error);
    callback(false)
  })
};

/* 
    Get a route.
*/
export const getRoute = (routeId, callback) => (dispatch) => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/routes`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_ROUTE,
      payload: {
        routes: res.data.routes,
        routeId: routeId
      }
    });

    callback(true);
  }).catch((error) => {
    console.log(error);
    callback(false)
  })
};


/*
	Generate routes in the hierarchy from customer data
*/
export const generateRoutes = (existingInstanceId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/sync/routes` + (existingInstanceId != null ? `/${existingInstanceId}` : ""), {
    method: existingInstanceId != null ? "get" : "post"
  }).then(res => {
    dispatch({
      type: SYNC_ROUTES,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);

    if (error.response?.data?.runtimeStatus != null) {
      dispatch({
        type: SYNC_ROUTES,
        payload: error.response.data
      });
    }

    callback(false);
  })
};